var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 184.975 81.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__prefix__prefix__cls-1{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__prefix__prefix__Group_270",
    "data-name": "Group 270",
    transform: "translate(-1311.686 3825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_38",
    "data-name": "Path 38",
    className: "prefix__prefix__prefix__cls-1",
    d: "M111.3 174.95h32.643v15.113H111.3z",
    transform: "translate(1200.386 -3999.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_39",
    "data-name": "Path 39",
    className: "prefix__prefix__prefix__cls-1",
    d: "M199.06 174.95h32.64v15.113h-32.64z",
    transform: "translate(1146.63 -3999.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_40",
    "data-name": "Path 40",
    className: "prefix__prefix__prefix__cls-1",
    d: "M286.82 174.95h32.643v15.113H286.82z",
    transform: "translate(1092.875 -3999.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_41",
    "data-name": "Path 41",
    className: "prefix__prefix__prefix__cls-1",
    d: "M374.57 174.95h32.643v15.113H374.57z",
    transform: "translate(1039.125 -3999.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_42",
    "data-name": "Path 42",
    className: "prefix__prefix__prefix__cls-1",
    d: "M462.33 174.95h32.646v15.113H462.33z",
    transform: "translate(985.369 -3999.95)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_43",
    "data-name": "Path 43",
    className: "prefix__prefix__prefix__cls-1",
    d: "M153.42 217.07h32.643v15.113H153.42z",
    transform: "translate(1174.586 -4025.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_44",
    "data-name": "Path 44",
    className: "prefix__prefix__prefix__cls-1",
    d: "M241.18 217.07h32.643v15.113H241.18z",
    transform: "translate(1120.831 -4025.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_45",
    "data-name": "Path 45",
    className: "prefix__prefix__prefix__cls-1",
    d: "M328.94 217.07h32.643v15.113H328.94z",
    transform: "translate(1067.075 -4025.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_46",
    "data-name": "Path 46",
    className: "prefix__prefix__prefix__cls-1",
    d: "M416.7 217.07h32.643v15.113H416.7z",
    transform: "translate(1013.319 -4025.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_47",
    "data-name": "Path 47",
    className: "prefix__prefix__prefix__cls-1",
    d: "M504.45 217.07h32.643v15.113H504.45z",
    transform: "translate(959.569 -4025.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_48",
    "data-name": "Path 48",
    className: "prefix__prefix__prefix__cls-1",
    d: "M153.42 303.05h32.643v15.113H153.42z",
    transform: "translate(1174.586 -4078.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_49",
    "data-name": "Path 49",
    className: "prefix__prefix__prefix__cls-1",
    d: "M241.18 303.05h32.643v15.113H241.18z",
    transform: "translate(1120.831 -4078.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_50",
    "data-name": "Path 50",
    className: "prefix__prefix__prefix__cls-1",
    d: "M328.94 303.05h32.643v15.113H328.94z",
    transform: "translate(1067.075 -4078.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_51",
    "data-name": "Path 51",
    className: "prefix__prefix__prefix__cls-1",
    d: "M416.7 303.05h32.643v15.113H416.7z",
    transform: "translate(1013.319 -4078.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_52",
    "data-name": "Path 52",
    className: "prefix__prefix__prefix__cls-1",
    d: "M504.45 303.05h32.643v15.113H504.45z",
    transform: "translate(959.569 -4078.416)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_53",
    "data-name": "Path 53",
    className: "prefix__prefix__prefix__cls-1",
    d: "M111.3 259.48h32.643v15.113H111.3z",
    transform: "translate(1200.386 -4051.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_54",
    "data-name": "Path 54",
    className: "prefix__prefix__prefix__cls-1",
    d: "M199.06 259.48h32.64v15.113h-32.64z",
    transform: "translate(1146.63 -4051.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_55",
    "data-name": "Path 55",
    className: "prefix__prefix__prefix__cls-1",
    d: "M286.82 259.48h32.643v15.113H286.82z",
    transform: "translate(1092.875 -4051.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_56",
    "data-name": "Path 56",
    className: "prefix__prefix__prefix__cls-1",
    d: "M374.57 259.48h32.643v15.113H374.57z",
    transform: "translate(1039.125 -4051.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_57",
    "data-name": "Path 57",
    className: "prefix__prefix__prefix__cls-1",
    d: "M462.33 259.48h32.646v15.113H462.33z",
    transform: "translate(985.369 -4051.728)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_58",
    "data-name": "Path 58",
    className: "prefix__prefix__prefix__cls-1",
    d: "M111.3 346.05h32.643v15.113H111.3z",
    transform: "translate(1200.386 -4104.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_59",
    "data-name": "Path 59",
    className: "prefix__prefix__prefix__cls-1",
    d: "M199.06 346.05h32.64v15.113h-32.64z",
    transform: "translate(1146.63 -4104.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_60",
    "data-name": "Path 60",
    className: "prefix__prefix__prefix__cls-1",
    d: "M286.82 346.05h32.643v15.113H286.82z",
    transform: "translate(1092.875 -4104.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_61",
    "data-name": "Path 61",
    className: "prefix__prefix__prefix__cls-1",
    d: "M374.57 346.05h32.643v15.113H374.57z",
    transform: "translate(1039.125 -4104.754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__prefix__prefix__Path_62",
    "data-name": "Path 62",
    className: "prefix__prefix__prefix__cls-1",
    d: "M462.33 346.05h32.646v15.113H462.33z",
    transform: "translate(985.369 -4104.754)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWall);
export default __webpack_public_path__ + "static/media/wall.49e380b2.svg";
export { ForwardRef as ReactComponent };